<div>
    <mat-form-field appearance="outline" class="w-full custom-select no-bottom-padding">
        <mat-label>{{label}}</mat-label>
        
        <mat-select multiple 
            [(ngModel)]="ids"
            (ngModelChange)="onModelChange($event)"
            (openedChange)="isPanelOpen = $event"
            panelClass="custom-select-panel" 
            placeholder="Seleccionar...">
            
            <mat-select-trigger>
                {{ selectedTriggerText }}
            </mat-select-trigger>

            <mat-option *ngFor="let item of items" [value]="item.id">
                {{ item.name }}
            </mat-option>
        </mat-select>

        <i matSuffix 
           class="fa-solid fa-chevron-down text-[#00539D] text-xs transition-transform duration-300 mr-2"
           [style.transform]="isPanelOpen ? 'rotate(180deg)' : 'rotate(0deg)'"></i>
    </mat-form-field>
</div>